import TaxonomyService from '../services/Taxonomy.service';
import { observable, action } from 'mobx';

class TaxonomyStore {
  taxonomy = observable(new Map());

  constructor() {
    this.fetchTaxonomy();
  }

  getTaxonomyByName(codename) {
    return this.taxonomy.get(codename);
  }

  @action
  async fetchTaxonomy() {
    try {
      const items = await TaxonomyService.fetchTaxonomy();
      if (items.isEmpty) {
        return null;
      }

      items.taxonomies.forEach(tax =>
        this.taxonomy.set(tax.system.codename, tax.terms)
      );
    } catch (e) {
      console.error('Failed to fetch taxonomy', e);
      return null;
    }
  }
}

export default new TaxonomyStore();



// WEBPACK FOOTER //
// ./src/stores/Taxonomy.store.js